/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Add_BlockInputs */



/**
* | output |
* | --- |
* | "Add block" |
*
* @param {Rte_Add_BlockInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_add_block = /** @type {((inputs?: Rte_Add_BlockInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Add_BlockInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Blok toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un bloc")
	return /** @type {LocalizedString} */ ("Add block")
});